import * as SentryLib from "@sentry/react";

const Sentry = SentryLib;

// Environment checks
const isProd = process.env.NODE_ENV === "production";
const isDev = process.env.NODE_ENV === "development";
const enableForTesting = false;
const sentryEnabled = isProd || enableForTesting;

/**
 * Initialize Sentry
 */
export function initSentry() {
  if (!sentryEnabled) {
    console.log("Sentry disabled - not in production mode");
    return;
  }

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    release: "0.1.0",

    // Performance monitoring
    tracesSampleRate: isProd ? 0.1 : 1.0,

    // Session replay
    replaysSessionSampleRate: isProd ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,

    // Ignore specific errors
    ignoreErrors: [
      "Network Error",
      "Failed to fetch",
      "Request timeout",
      "ResizeObserver loop limit exceeded",
      "Script error.",
      "WebSocket connection",
      ...(isDev
        ? [
            "Hydration failed",
            "Text content did not match server-rendered HTML",
          ]
        : []),
    ],

    // Ignore localhost URLs in production
    denyUrls: isProd ? [/localhost/, /127\.0\.0\.1/, /0\.0\.0\.0/] : [],

    // Filter events before sending
    beforeSend(event, hint) {
      if (isDev && !enableForTesting) return null;

      const error = hint.originalException;
      if (error?.message?.includes("reload")) return null;

      return event;
    },

    // Filter breadcrumbs
    beforeBreadcrumb(breadcrumb) {
      return breadcrumb.category === "console" && breadcrumb.level === "log"
        ? null
        : breadcrumb;
    },

    // Misc
    debug: isDev,
    maxBreadcrumbs: 50,
    maxEventSize: 1000000, // 1 MB
  });

  console.log("Sentry initialized successfully");

  const userInfo = localStorage.getItem("currentUser");

  if (!userInfo) return;

  const parsed = JSON.parse(userInfo);

  Sentry.setUser({
    mobile: parsed.mobile,
    name: parsed.name,
    organization: parsed.org_name,
  });
}

// Export Sentry instance
export { Sentry };
